import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

import { NgxMaskModule } from 'ngx-mask';
import { NgxPaginationModule } from 'ngx-pagination';

import { AcaoCancelarProcedimentoComponent } from './components/acoes/acao-cancelar-procedimento/acao-cancelar-procedimento.component';

// Components
import { AppComponent } from './app.component';
import { AcaoCancelarComponent } from './components/acoes/acao-cancelar/acao-cancelar.component';
import { AcaoFinalizarComponent } from './components/acoes/acao-finalizar/acao-finalizar.component';
import { AcaoProrrogarComponent } from './components/acoes/acao-prorrogar/acao-prorrogar.component';
import { AcaoSalvarComponent } from './components/acoes/acao-salvar/acao-salvar.component';
import { AcoesComponent } from './components/acoes/acoes.component';
import { AlterarSenhaComponent } from './components/alterar-senha/alterar-senha.component';
import { AnexarImagensComponent } from './components/anexar-imagens/anexar-imagens.component';
import { AnexarImagensLabelComponent } from './components/anexar-imagens-label/anexar-imagens-label.component';
import { BuscarGtoComponent } from './components/dashboard/gto-dashboard/buscar-gto/buscar-gto.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { ComunicadoImportanteComponent } from './components/comunicados/comunicado-importante/comunicado-importante.component';
import { ComunicadoSimplesComponent } from './components/comunicados/comunicado-simples/comunicado-simples.component';
import { ComunicadosComponent } from './components/comunicados/comunicados.component';
import { ConsultaElegibilidadeComponent } from './components/consulta-elegibilidade/consulta-elegibilidade.component';
import { DadosPrestadorComponent } from './components/dados-prestador/dados-prestador.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DemonstrativoPagamentoComponent } from './components/demonstrativo-pagamento/demonstrativo-pagamento.component';
import { EsqueceuSenhaComponent } from './components/esqueceu-senha/esqueceu-senha.component';
import { FiltroPlanosComponent } from './components/nova-gto/planos-tratamento/filtro-planos/filtro-planos.component';
import { FooterComponent } from './components/base/footer/footer.component';
import { FrontInterceptor } from './components/base/util/front.interceptor';
import { GenericoPlanosComponent } from './components/nova-gto/planos-tratamento/generico-planos/generico-planos.component';
import { GetImageComponent } from './components/get-image/get-image.component';
import { Globals } from './components/base/util/globals';
import { GtoDashboardComponent } from './components/dashboard/gto-dashboard/gto-dashboard.component';
import { GtoDetalhesComponent } from './components/gto-detalhes/gto-detalhes.component';
import { GtoFinalizarComponent } from './components/gto-finalizar/gto-finalizar.component';
import { GtoTokenComponent } from './components/gto-token/gto-token.component';
import { HeaderComponent } from './components/base/header/header.component';
import { HeaderGtoDashboardComponent } from './components/dashboard/header-gto-dashboard/header-gto-dashboard.component';
import { IdentificarPrestadorExecutanteComponent } from './components/identificar-prestador-executante/identificar-prestador-executante.component';
import { ImagemProcedimentoComponent } from './components/base/imagem-procedimento/imagem-procedimento.component';
import { ImagensTratamentoComponent } from './components/imagens-tratamento/imagens-tratamento.component';
import { ImgDocuwareComponent } from './components/img-docuware/img-docuware.component';
import { ItensTratamentoComponent } from './components/itens-tratamento/itens-tratamento.component';
import { LoadingComponent } from './components/loading/loading.component';
import { LoginComponent } from './components/login/login.component';
import { MaterialApoioComponent } from './components/material-apoio/material-apoio.component';
import { ModalComponent } from './components/modal/modal.component';
import { ModalDocumentosComponent } from './components/modal-documentos/modal-documentos.component';
import { ModalFinalizarComponent } from './components/gto-finalizar/modal-finalizar/modal-finalizar.component';
import { ModalGlosasProcedimentoComponent } from './components/gto-detalhes/modal-glosas-procedimento/modal-glosas-procedimento.component';
import { ModalSalvarAlteracoesComponent } from './components/gto-finalizar/modal-salvar-alteracoes/modal-salvar-alteracoes.component';
import { ModalStepComponent } from './components/modal-documentos/modal-step/modal-step.component';
import { ModalSucessoComponent } from './components/modal/modal-sucesso/modal-sucesso.component';
import { ModalVinculoComponent } from './components/admin/contratos/admin-contratos-novo/form-vinculo/modal-vinculo/modal-vinculo.component';
import { NovaGtoComponent } from './components/nova-gto/nova-gto.component';
import { OrtodontiaComponent } from './components/ortodontia/ortodontia/ortodontia.component';
import { PaginacaoComponent } from './components/base/paginacao/paginacao.component';
import { PlanosTratamentoComponent } from './components/nova-gto/planos-tratamento/planos-tratamento.component';
import { PopupComponent } from './components/popup/popup.component';
import { PortalTissComponent } from './components/portal-tiss/portal-tiss.component';
import { PrimeiraOrtodontiaPasso1Component } from './components/ortodontia/primeira-ortodontia-passo-1/primeira-ortodontia-passo-1.component';
import { PrimeiraOrtodontiaPasso2Component } from './components/ortodontia/primeira-ortodontia-passo-2/primeira-ortodontia-passo-2.component';
import { ProcedimentoFacesComponent } from './components/procedimento-faces/procedimento-faces.component';
import { ProrrogacaoOrtodontiaComponent } from './components/ortodontia/prorrogacao-ortodontia/prorrogacao-ortodontia.component';
import { ResendTokenComponent } from './components/gto-token/resend-token/resend-token.component';
import { ResumoComponent } from './components/nova-gto/resumo/resumo.component';
import { ResumoOrtodontiaComponent } from './components/ortodontia/resumo-ortodontia/resumo-ortodontia.component';
import { StatesComponent } from './components/states/states.component';
import { TabelaPlanejamentoComponent } from './components/tabela-planejamento/tabela-planejamento.component';
import { UltimosComunicadosComponent } from './components/dashboard/ultimos-comunicados/ultimos-comunicados.component';
import { UltimosComunicadosImportanteComponent } from './components/dashboard/ultimos-comunicados/ultimos-comunicados-importante/ultimos-comunicados-importante.component';
import { UltimosComunicadosSimplesComponent } from './components/dashboard/ultimos-comunicados/ultimos-comunicados-simples/ultimos-comunicados-simples.component';
import { UrlHelperService } from './components/base/util/url-helper.service';
import { UsuarioDashboardComponent } from './components/dashboard/usuario-dashboard/usuario-dashboard.component';
import { ValidateTokenComponent } from './components/gto-token/validate-token/validate-token.component';
import { WithoutTokenComponent } from './components/gto-token/without-token/without-token.component';

// Services
import { AcoesService } from './components/acoes/acoes.service';
import { AlterarSenhaService } from './components/alterar-senha/alterar-senha.service';
import { AnexarImagensService } from './components/anexar-imagens/anexar-imagens.service';
import { AutenticacaoService } from './components/autenticacao/autenticacao.service';
import { AuthGuardService } from './components/autenticacao/auth-guard.service';
import { BuscarGtoService } from './components/dashboard/gto-dashboard/buscar-gto/buscar-gto.service';
import { ChatbotService } from './components/chatbot/chatbot.service';
import { ComunicadosService } from './components/comunicados/comunicados.service';
import { ConsultarElegibilidadeService } from './components/consulta-elegibilidade/consulta-elegibilidade.service';
import { DadosPrestadorService } from './components/dados-prestador/dados-prestador.service';
import { DemonstrativoPagamentoService } from './components/demonstrativo-pagamento/demonstrativo-pagamento.service';
import { DetalharGtoService } from './components/gto-detalhes/gto-detalhes.service';
import { DropDownService } from './components/base/util/dropdown.service';
import { EsqueceuSenhaService } from './components/esqueceu-senha/esqueceu-senha.service';
import { EventEmitterService } from './components/base/util/event-emitter.service';
import { FinalizarGtoService } from './components/gto-finalizar/gto-finalizar.service';
import { IdentificarPrestadorExecutanteService } from './components/identificar-prestador-executante/identificar-prestador-executante.service';
import { LogService } from './components/gto-detalhes/log.service';
import { MaterialApoioService } from './components/material-apoio/material-apoio.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { ModalDocumentoService } from './components/modal-documentos/modal-documentos.service';
import { NovaGtoService } from './components/nova-gto/nova-gto.service';
import { PopupService } from './components/popup/popup.service';
import { UsuarioDashboardService } from './components/dashboard/usuario-dashboard/usuario-dashboard.service';

// ADMIN
import { AdminComunicadosComponent } from './components/admin/comunicados/admin-comunicados.component';
import { AdminComunicadosService } from './components/admin/comunicados/admin-comunicados.service';
import { AdminComunicadosInserirComponent } from './components/admin/comunicados/inserir/admin-comunicados-inserir.component';
import { AdminConfigsComponent } from './components/admin/configs/admin-configs.component';
import { AdminConfigsService } from './components/admin/configs/admin-configs.service';
import { AdminContratosAcoesComponent } from './components/admin/contratos/admin-contratos-acoes/admin-contratos-acoes.component';

// ADMIN Contratos
import { AdminContratosListaComponent } from './components/admin/contratos/admin-contratos-lista/admin-contratos-lista.component';
import { AdminContratosComponent } from './components/admin/contratos/admin-contratos.component';
import { AdminContratosService } from './components/admin/contratos/admin-contratos.service';
import { AdminContratosNovoComponent } from './components/admin/contratos/admin-contratos-novo/admin-contratos-novo.component';
import { AdminContratosVisualizarComponent } from './components/admin/contratos/admin-contratos-visualizar/admin-contratos-visualizar.component';
import { FormNovoComponent } from './components/admin/contratos/admin-contratos-novo/form-novo/form-novo.component';
import { FormVinculoComponent } from './components/admin/contratos/admin-contratos-novo/form-vinculo/form-vinculo.component';
import { ModalExcluirComponent } from './components/admin/contratos/admin-contratos-lista/modal-excluir/modal-excluir.component';

// Pipes
import { CpfCnpjPipe } from './pipes/mascara-cpf-cnpj.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { EmptyPipe } from './pipes/empty.pipe';
import { EscapeHtmlPipe } from './pipes/keep-html.pipe';
import { OrderByPipe } from './pipes/orderby.pipe';
import { ReplaceLineBreaks } from './pipes/replace-line-breaks.pipe';
import { SecurePipe } from './pipes/secure.pipe';
import { StatusPipe } from './pipes/status.pipe';
import { TelefonePipe } from './pipes/mascara-telefone.pipe';
import { UseHttpImageSourcePipe } from './pipes/use-http-img-src';

// Inputs
import { InputCheckboxComponent } from './components/formulario/input-checkbox/input-checkbox.component';
import { InputEditorComponent } from './components/formulario/input-editor/input-editor.component';
import { InputPrimeDatepickerComponent } from './components/formulario/input-prime-datepicker/input-prime-datepicker.component';
import { InputPrimeDropdownComponent } from './components/formulario/input-prime-dropdown/input-prime-dropdown.component';
import { InputSelectComponent } from './components/formulario/input-select/input-select.component';
import { InputTextComponent } from './components/formulario/input-text/input-text.component';
import { InputUploadComponent } from './components/formulario/input-upload/input-upload.component';

// PrimeNG Imports - inserir abaixo
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { GrowlModule } from 'primeng/growl';
import { EditorModule } from 'primeng/editor';
import { GtoTokenService } from './components/gto-token/gto-token.service';


const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'esqueceu-senha', component: EsqueceuSenhaComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService] },
  { path: 'nova-gto', component: NovaGtoComponent, canActivate: [AuthGuardService] },
  { path: 'detalhagto/:numeroGTO', component: GtoDetalhesComponent, canActivate: [AuthGuardService] },
  { path: 'detalhagto/:numeroGTO/finalizar', component: GtoFinalizarComponent, canActivate: [AuthGuardService] },
  { path: 'comunicados', component: ComunicadosComponent, canActivate: [AuthGuardService] },
  { path: 'novo', component: PrimeiraOrtodontiaPasso1Component, canActivate: [AuthGuardService] },
  { path: 'demonstrativo-pagamento', component: DemonstrativoPagamentoComponent, canActivate: [AuthGuardService] },
  { path: 'procedimento-faces', component: ProcedimentoFacesComponent, canActivate: [AuthGuardService] },
  { path: 'dados-cadastrais', component: DadosPrestadorComponent, canActivate: [AuthGuardService] },
  { path: 'material-apoio', component: MaterialApoioComponent, canActivate: [AuthGuardService] },
  { path: 'portal-tiss', component: PortalTissComponent, canActivate: [AuthGuardService] },
  { path: 'get-image/:docuwareID', component: GetImageComponent, canActivate: [AuthGuardService] },
  { path: 'admin/comunicados', component: AdminComunicadosComponent, canActivate: [AuthGuardService] },
  { path: 'admin/comunicados/inserir', component: AdminComunicadosInserirComponent, canActivate: [AuthGuardService], children: [] },
  {
    path: 'admin/contratos',
    component: AdminContratosComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        component: AdminContratosListaComponent,
      },
      {
        path: 'criar-contrato',
        component: AdminContratosNovoComponent,
      },
      {
        path: 'vincular/:id',
        component: AdminContratosNovoComponent,
      },
      {
        path: 'editar/:id',
        component: AdminContratosNovoComponent,
      },
      {
        path: 'visualizar/:id',
        component: AdminContratosVisualizarComponent,
      }
    ]
  },
  { path: 'admin/configs', component: AdminConfigsComponent, canActivate: [AuthGuardService] },
  { path: '404', component: LoginComponent, canActivate: [AuthGuardService] },
  { path: '**', component: LoginComponent, canActivate: [AuthGuardService] }
];

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    AcaoCancelarComponent,
    AcaoCancelarProcedimentoComponent,
    AcaoCancelarProcedimentoComponent,
    AcaoFinalizarComponent,
    AcaoFinalizarComponent,
    AcaoProrrogarComponent,
    AcaoProrrogarComponent,
    AcaoSalvarComponent,
    AcaoSalvarComponent,
    AcoesComponent,
    AcoesComponent,
    AdminComunicadosComponent,
    AdminComunicadosComponent,
    AdminComunicadosInserirComponent,
    AdminComunicadosInserirComponent,
    AdminConfigsComponent,
    AdminConfigsComponent,
    AdminContratosAcoesComponent,
    AdminContratosComponent,
    AdminContratosListaComponent,
    AdminContratosNovoComponent,
    AdminContratosVisualizarComponent,
    AlterarSenhaComponent,
    AlterarSenhaComponent,
    AnexarImagensComponent,
    AnexarImagensComponent,
    AnexarImagensLabelComponent,
    BuscarGtoComponent,
    ChatbotComponent,
    ComunicadoImportanteComponent,
    ComunicadoSimplesComponent,
    ComunicadosComponent,
    ConsultaElegibilidadeComponent,
    CpfCnpjPipe,
    DadosPrestadorComponent,
    DashboardComponent,
    DemonstrativoPagamentoComponent,
    EllipsisPipe,
    EmptyPipe,
    EscapeHtmlPipe,
    EsqueceuSenhaComponent,
    FiltroPlanosComponent,
    FooterComponent,
    FormNovoComponent,
    FormVinculoComponent,
    GenericoPlanosComponent,
    GetImageComponent,
    GtoDashboardComponent,
    GtoDetalhesComponent,
    GtoFinalizarComponent,
    GtoTokenComponent,
    HeaderComponent,
    HeaderGtoDashboardComponent,
    IdentificarPrestadorExecutanteComponent,
    ImagemProcedimentoComponent,
    ImagensTratamentoComponent,
    ImgDocuwareComponent,
    InputCheckboxComponent,
    InputEditorComponent,
    InputPrimeDatepickerComponent,
    InputPrimeDropdownComponent,
    InputSelectComponent,
    InputTextComponent,
    InputUploadComponent,
    ItensTratamentoComponent,
    LoadingComponent,
    LoginComponent,
    MaterialApoioComponent,
    ModalComponent,
    ModalDocumentosComponent,
    ModalExcluirComponent,
    ModalFinalizarComponent,
    ModalGlosasProcedimentoComponent,
    ModalSalvarAlteracoesComponent,
    ModalStepComponent,
    ModalSucessoComponent,
    ModalVinculoComponent,
    NovaGtoComponent,
    OrderByPipe,
    OrtodontiaComponent,
    PaginacaoComponent,
    PlanosTratamentoComponent,
    PopupComponent,
    PortalTissComponent,
    PrimeiraOrtodontiaPasso1Component,
    PrimeiraOrtodontiaPasso2Component,
    ProcedimentoFacesComponent,
    ProrrogacaoOrtodontiaComponent,
    ReplaceLineBreaks,
    ResendTokenComponent,
    ResumoComponent,
    ResumoComponent,
    ResumoOrtodontiaComponent,
    ResumoOrtodontiaComponent,
    SecurePipe,
    StatesComponent,
    StatusPipe,
    UseHttpImageSourcePipe,
    TabelaPlanejamentoComponent,
    TelefonePipe,
    UltimosComunicadosComponent,
    UltimosComunicadosImportanteComponent,
    UltimosComunicadosSimplesComponent,
    UsuarioDashboardComponent,
    ValidateTokenComponent,
    WithoutTokenComponent,
  ],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      // { enableTracing: true } // <-- debugging purposes only
    ),
    BrowserModule,
    BrowserAnimationsModule,
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    DialogModule,
    DropdownModule,
    EditorModule,
    FormsModule,
    GrowlModule,
    HttpClientModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatTooltipModule,
    MenuModule,
    NgxMaskModule.forRoot(),
    NgxPaginationModule,
    OverlayPanelModule,
    ProgressBarModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    TabViewModule,
    TableModule,
  ],
  providers: [
    AcoesService,
    AdminComunicadosService,
    AdminConfigsService,
    AdminContratosService,
    AnexarImagensService,
    AutenticacaoService,
    AuthGuardService,
    BuscarGtoService,
    ComunicadosService,
    ConsultarElegibilidadeService,
    DadosPrestadorService,
    DemonstrativoPagamentoService,
    DetalharGtoService,
    DropDownService,
    EsqueceuSenhaService,
    EventEmitterService,
    FinalizarGtoService,
    GtoTokenService,
    IdentificarPrestadorExecutanteService,
    LogService,
    MaterialApoioService,
    ModalDocumentoService,
    NovaGtoService,
    PopupService,
    UrlHelperService,
    UsuarioDashboardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FrontInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    Globals,
    MessageService,
    AlterarSenhaService,
    ChatbotService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts